import React, { Suspense, useEffect } from "react"

import { Routes, Route, BrowserRouter as Router } from "react-router-dom"
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';

// Import Routes all
import { protectedRoutes, publicRoutes } from "./routes"

// Import all middleware
import Authmiddleware from "~/routes/route"

// layouts Format
import VerticalLayout from "~/components/VerticalLayout/"
import NonAuthLayout from "~/components/NonAuthLayout"
import NotFound from "~/pages/Error/NotFound"
import Preloader from "~/components/Shared/Preloader"

// Import scss
import "./assets/scss/theme.scss"

import { initializeTagManager } from '~/hooks/gtm';

const EMPTY_PROPS = {};

const App = () => {

  useEffect(() => {
    initializeTagManager();
  }, [])

  return (
    <React.Fragment>
      <ReactNotifications />
      <Router>
        <Suspense fallback={<Preloader />}>
        <Routes>
          {publicRoutes.map((route) => <Route key={route.path} path={route.path} element={<Authmiddleware
            layout={NonAuthLayout}
            component={route.component}
            componentProps={route.props || EMPTY_PROPS}
            isProtected={false}
            isStrict={route.isStrict || false}
          />} />)}
          {protectedRoutes.map((route) => <Route key={route.path} path={route.path} element={<Authmiddleware
            layout={route.layout || VerticalLayout}
            component={route.component}
            componentProps={route.props || EMPTY_PROPS}
            isProtected={true}
          />} />)}
          <Route element={<NotFound title="Page not found" />} />
        </Routes>
        </Suspense>
      </Router>
    </React.Fragment>
  )
}

export default App
